import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "token" }
const _hoisted_2 = { class: "token__name" }
const _hoisted_3 = { class: "token__created-date" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Revoke ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.name), 1),
    _createElementVNode("span", _hoisted_3, " | created " + _toDisplayString(_ctx.formattedDate), 1),
    _createVNode(_component_loading_button, {
      "button-type": "button",
      class: "token__delete-button",
      "show-arrow": false,
      loading: false,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('revoked', _ctx.id)))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}